import { useRef } from "react";
import * as styles from "./PreviewChip.style.ts";
import type { ChangeEvent } from "react";
import { ChipV2 } from "src/components/ChipV2/ChipV2.tsx";
import type { Config } from "src/components/DropZoneInputV2/types.ts";
import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { TooltipV3 } from "src/components/TooltipV3/TooltipV3.tsx";

type RowProps = {
  url?: string;
  imageName: string;
  onRemove(): void;
  onReplace(newFile: File): void;
  errors?: string[];
  validationRules?: Partial<Config["validationRules"]>;
};

export const PreviewChip = (props: RowProps) => {
  const {
    imageName,
    onRemove,
    onReplace,
    validationRules,
    errors = [],
  } = props;
  const accept = validationRules?.accept || [];
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.target.files &&
      event.target.files[0] &&
      onReplace(event.target.files[0]);
  };

  const handleReplaceClick = () => {
    inputRef.current && inputRef.current.click();
  };

  return (
    <div css={styles.root} onClick={handleReplaceClick}>
      <input
        type="file"
        accept={accept.length > 0 ? accept.join(",") : undefined}
        hidden
        ref={inputRef}
        onChange={handleFileChange}
      />

      <ChipV2
        label={<Label imageName={imageName} errors={errors} />}
        onDelete={() => {
          onRemove();
        }}
      />
    </div>
  );
};

const Label = ({
  imageName,
  errors,
}: {
  imageName: string;
  errors: string[];
}) => {
  return (
    <div>
      {imageName}{" "}
      {!!errors?.length && (
        <TooltipV3 content={errors}>
          <span css={warningStyles} className={"icon-15-warning"} />
        </TooltipV3>
      )}
    </div>
  );
};

const warningStyles = (theme: ExactTheme) =>
  css({
    color: theme.colorsV2.red[500],
  });
